import { configurationSettings, LoyaltyMemberIdentifier } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { captchaFieldDisplayTextValidator, defaultCaptchaFieldDisplayText } from '../../../../subcomponents/form/field/captcha/types/display-text';
import { inputFieldDisplayTextValidator } from '../../../../subcomponents/form/field/input/types/display-text';
import { InvalidFieldNameError } from '../../../../types/invalid-field-name-error';
import { defaultMemberPasswordResetCreateFormEmailFieldDisplayText, defaultMemberPasswordResetCreateFormUsernameFieldDisplayText } from './display-text';
import { MemberPasswordResetCreateFormFieldName } from './name';
const memberPasswordResetCreateFormInputFieldPropsValidator = Validator.object({
    name: Validator.isEqualTo(MemberPasswordResetCreateFormFieldName.Identifier),
    displayText: inputFieldDisplayTextValidator
});
const memberPasswordResetCreateFormCaptchaFieldPropsValidator = Validator.object({
    name: Validator.isEqualTo(MemberPasswordResetCreateFormFieldName.Captcha),
    displayText: captchaFieldDisplayTextValidator
});
const defaultEmailFieldProps = {
    name: MemberPasswordResetCreateFormFieldName.Identifier,
    displayText: defaultMemberPasswordResetCreateFormEmailFieldDisplayText
};
const defaultUsernameFieldProps = {
    name: MemberPasswordResetCreateFormFieldName.Identifier,
    displayText: defaultMemberPasswordResetCreateFormUsernameFieldDisplayText
};
const defaultCaptchaFieldProps = {
    name: MemberPasswordResetCreateFormFieldName.Captcha,
    displayText: defaultCaptchaFieldDisplayText
};
export const memberPasswordResetCreateFormFieldPropsValidator = Validator.any([
    memberPasswordResetCreateFormInputFieldPropsValidator,
    memberPasswordResetCreateFormCaptchaFieldPropsValidator
]);
export const defaultMemberPasswordResetCreateFormFieldPropsProvider = props => {
    switch (props.name) {
        case MemberPasswordResetCreateFormFieldName.Identifier: {
            return configurationSettings.data.loyalty.authentication.memberIdentifier === LoyaltyMemberIdentifier.Email
                ? defaultEmailFieldProps
                : defaultUsernameFieldProps;
        }
        case MemberPasswordResetCreateFormFieldName.Captcha:
            return defaultCaptchaFieldProps;
        default:
            throw new InvalidFieldNameError('MemberPasswordResetCreateFormField', props.name);
    }
};
